import { LockPersonIcon } from "./LockPersonIcon"
import React from "react"
import moment from 'moment'
import 'moment/locale/pt-br'
// A imagem passa pelos ASSET MODULES nativos do webpack 5 (`type: 'asset/resource'` em
// webpack.common.js), que geram `module.exports = <url>` — a URL é o próprio valor do módulo.
// Um `import ... from` (ou `require(...)` sem `.default`) devolve essa string. Era `.default`,
// que valia no file-loader antigo (`esModule: true`) e virou `undefined` na migração para
// webpack 5: o `<img>` ficava com `src` nulo e o logo do login não aparecia.
import logoMicro from '../../../images/logo-micro.png'
const estilosCabecalhoLogo = require('./cabecalho-logo.module.scss').default
moment.locale('pt-br')

export type CabecalhoLogoProps = {
    urlLogo: string
}

export const CabecalhoLogo = (props: CabecalhoLogoProps) => {
    
    return <>
        <div className="_flex _flex-row _bg-white">
            <div className={estilosCabecalhoLogo.cadeado}
                id="CabecalhoLogo_Cadeado"
            >
                <LockPersonIcon fontSize="large" />
            </div>

            <div className={estilosCabecalhoLogo.logo}
                id="CabecalhoLogo_Logo"
                style={{width: '167px', height: '70px'}}
            >
                <img src={props.urlLogo || logoMicro} alt="logo"/>
            </div>

            <div className={estilosCabecalhoLogo.data}
                id="CabecalhoLogo_Data"
            >
                {moment().format('dddd, DD/MM/YYYY')}
            </div>
        </div>
    </>
}
